import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToggleSlideOptions, ControlLayout, DropdownOptions, InputType, TextBoxOptions, CheckBoxOptions } from 'bnsights-control-library';
import { DataSecretService } from '../../shared/Services/data.service';
import { ActiveDirectoryService } from '../../shared/Services/ActiveDirectoryService.service';
import { ActiveDirectoryAddEditModel } from '../../shared/models/ADModels/ActiveDirectoryAddEditModel';
import { ADMappingModel } from '../../shared/models/ADModels/ADMappingModel';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';


@Component({
  selector: 'lib-active-directory-add',
  templateUrl: './active-directory-add.component.html'
})
export class ActiveDirectoryAddComponent implements OnInit, AfterViewInit, OnDestroy {
  ApiUrl = "/api/admin/ADConnection/";
  language: string = "";
  ProductionMode: boolean = false;
  //wizard
  formsCount = 3;
  currentStep$: BehaviorSubject<number> = new BehaviorSubject(1);
  //wizard
  PermissionSetList: any[] = [];
  LanguagesList: any[] = [];
  WelcomeMsgTempList: any[] = [];
  ADTypesList: any[] = [];
  FileProviders: any[] = [];
  connectionTypeGroupId: number;

  mappingPropertiesList: any[] = [];
  mappingTypesList: any[] = [];
  @ViewChild('wizard', { static: true }) el: ElementRef;

  //Add Model Controls
  AddActiveDirectoryForm = new FormGroup({});
  AddTypeOptions: DropdownOptions;
  AddDomain: TextBoxOptions;
  AddSamAccount: TextBoxOptions;
  AddPassword: TextBoxOptions;
  AddSearchTree: TextBoxOptions;
  AddShowBuiltInGroups: ToggleSlideOptions;
  AddName: TextBoxOptions;
  AddPermissionSet: DropdownOptions;
  AddLanguage: DropdownOptions;
  AddWelcomeMsgTemp: DropdownOptions;
  AddFileProvider: DropdownOptions;
  AddMarkInactive: ToggleSlideOptions;
  AddDailyJob: ToggleSlideOptions;
  AddMappingsOptions: any[] = [];
  AddMappingsCount: number = 0;



  AddShowBuiltInGroupsVisible: boolean = false;
  IsAddFormLoaded: boolean = false;

  //AddDescription: TextAreaOptions;
  //AddOrganizationOptions: DropdownOptions;

  submitted = false;
  wizard: any;

  validationError: string;
  errorIsFound: boolean = false;
  treeNodeData: any;

  constructor(private pageInfoService: PageInfoService, public utilityService: UtilityService, private bbsfTranslateService: BBSFTranslateService, private environmentService: EnvironmentService, private dataServices: DataSecretService, private authService: AuthService, private ActiveDirectoryService: ActiveDirectoryService, private router: Router) {
  }

  async ngOnInit() {
    this.bbsfTranslateService.onLangChange.subscribe((event) => {
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.initializePage();


  }


  initializePage() {
    this.ActiveDirectoryService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.PermissionSetList = DropdownLists.permissionSets;
      this.ADTypesList = DropdownLists.adTypes;
      this.LanguagesList = DropdownLists.languages;
      this.WelcomeMsgTempList = DropdownLists.templates;
      this.FileProviders = DropdownLists.fileProviders;
      this.connectionTypeGroupId = DropdownLists.connectionTypeGroupId;

      this.mappingPropertiesList = DropdownLists.mappingProperties;
      this.mappingTypesList = DropdownLists.mappingTypes;

      this.AddActiveDirectoryForm.reset();
      this.AddDomain = new TextBoxOptions();
      this.AddDomain.Name = "AddDomain";
      this.AddDomain.LabelKey = "Domain";
      this.AddDomain.Type = InputType.Text;
      this.AddDomain.Value = null;
      this.AddDomain.IsRequired = true;

      this.AddSamAccount = new TextBoxOptions();
      this.AddSamAccount.Name = "AddSamAccount";
      this.AddSamAccount.LabelKey = "SamAccount";
      this.AddSamAccount.Type = InputType.Text;
      this.AddSamAccount.Value = null;

      this.AddPassword = new TextBoxOptions();
      this.AddPassword.Name = "AddPassword";
      this.AddPassword.LabelKey = "Password";
      this.AddPassword.Type = InputType.Password;
      this.AddPassword.Value = null;
      this.AddPassword.RemoveDefaultPasswordValidation = true;


      this.AddTypeOptions = new DropdownOptions();
      this.AddTypeOptions.Name = "AddTypeOptions"
      this.AddTypeOptions.LabelKey = "Type"
      this.AddTypeOptions.ViewType = ControlLayout.Horizontal
      this.AddTypeOptions.DataSource = this.ADTypesList
      this.AddTypeOptions.SingleSelection = true;
      this.AddTypeOptions.AllowSearchFilter = true;
      this.AddTypeOptions.Placeholder = "";
      this.AddTypeOptions.IsRequired = true;

      this.AddShowBuiltInGroups = new ToggleSlideOptions();
      this.AddShowBuiltInGroups.Name = "AddShowBuiltInGroups"
      this.AddShowBuiltInGroups.LabelValue = "ShowBuiltInGroups"
      this.AddShowBuiltInGroups.LabelKey = "ShowBuiltInGroups"
      this.AddShowBuiltInGroups.Value = false;
      this.AddShowBuiltInGroups.ViewType = ControlLayout.Horizontal;

      this.AddSearchTree = new TextBoxOptions();
      this.AddSearchTree.Name = "AddSearchTree";
      this.AddSearchTree.HideLabel = true;
      this.AddSearchTree.Type = InputType.Text;
      this.AddSearchTree.Value = null;

      this.AddName = new TextBoxOptions();
      this.AddName.Name = "AddName";
      this.AddName.LabelKey = "Name";
      this.AddName.Type = InputType.Text;
      this.AddName.Value = null;
      this.AddName.IsRequired = true;

      this.AddPermissionSet = new DropdownOptions();
      this.AddPermissionSet.Name = "AddPermissionSet"
      this.AddPermissionSet.LabelKey = "PermissionSet"
      this.AddPermissionSet.DataSource = this.PermissionSetList
      this.AddPermissionSet.SingleSelection = true;
      this.AddPermissionSet.AllowSearchFilter = true;
      this.AddPermissionSet.Placeholder = "PermissionSet";
      this.AddPermissionSet.IsRequired = true;

      this.AddLanguage = new DropdownOptions();
      this.AddLanguage.Name = "AddLanguage"
      this.AddLanguage.LabelKey = "Language"
      this.AddLanguage.DataSource = this.LanguagesList
      this.AddLanguage.SingleSelection = true;
      this.AddLanguage.AllowSearchFilter = true;
      this.AddLanguage.Placeholder = "";
      this.AddLanguage.IsRequired = true;

      this.AddWelcomeMsgTemp = new DropdownOptions();
      this.AddWelcomeMsgTemp.Name = "AddWelcomeMsgTemp"
      this.AddWelcomeMsgTemp.LabelKey = "WelcomeMsgTemplate"
      this.AddWelcomeMsgTemp.DataSource = this.WelcomeMsgTempList
      this.AddWelcomeMsgTemp.SingleSelection = true;
      this.AddWelcomeMsgTemp.AllowSearchFilter = true;
      this.AddWelcomeMsgTemp.Placeholder = "WelcomeMsgTemplate";

      this.AddFileProvider = new DropdownOptions();
      this.AddFileProvider.Name = "AddFileProvider"
      this.AddFileProvider.LabelKey = "FileProvider"
      this.AddFileProvider.DataSource = this.FileProviders
      this.AddFileProvider.SingleSelection = true;
      this.AddFileProvider.AllowSearchFilter = true;
      this.AddFileProvider.Placeholder = "WelcomeMsgTemplate";

      this.AddMarkInactive = new ToggleSlideOptions();
      this.AddMarkInactive.Name = "AddMarkInactive"
      this.AddMarkInactive.LabelKey = "MarkAsInactive"
      this.AddMarkInactive.Value = false;
      this.AddMarkInactive.ViewType = ControlLayout.Horizontal;

      this.AddDailyJob = new ToggleSlideOptions();
      this.AddDailyJob.Name = "AddDailyJob"
      this.AddDailyJob.LabelKey = "AddToDailyJob"
      this.AddDailyJob.Value = false;
      this.AddDailyJob.ViewType = ControlLayout.Horizontal;

      //set AD mapping
      let data: any = this.getADMappingOptions(DropdownLists.adMappings);
      this.AddMappingsOptions = data[0];
      this.AddMappingsCount = data[1];

      setTimeout(() => {
        this.IsAddFormLoaded = true;
      }, 50);

    });
  }
  getADMappingOptions(ADMappings: any[]) {
    let ADMappingOptions: any[] = [];
    let ADMappingCount: number = 0;
    for (let i = 0; i < ADMappings.length; i++) {

      let objectMappingOptions: any[] = [];

      let ADMappingType = new DropdownOptions();
      let selectedType = this.mappingTypesList.filter((item) => { return item.key == ADMappings[i].adMappingTypeItemID; }).map((item) => item.key)[0];
      ADMappingType.Name = "ADMappingType" + i;
      ADMappingType.HideLabel = true;
      ADMappingType.SingleSelection = true;
      ADMappingType.SelectedItems = selectedType;
      ADMappingType.ViewType = ControlLayout.Horizontal;
      ADMappingType.DataSource = this.mappingTypesList;
      ADMappingType.IsRequired = true;

      let ADMappingProperty = new DropdownOptions();
      let selectedProperty = this.mappingPropertiesList.filter((item) => { return item.key == ADMappings[i].bbsfPropertyName; }).map((item) => item.key)[0];
      ADMappingProperty.Name = "ADMappingProperty" + i;
      ADMappingProperty.HideLabel = true;
      ADMappingProperty.SingleSelection = true;
      ADMappingProperty.SelectedItems = selectedProperty;
      ADMappingProperty.ViewType = ControlLayout.Horizontal;
      ADMappingProperty.DataSource = this.mappingPropertiesList;
      ADMappingProperty.IsRequired = true;


      let ADMappingPropertyName = new TextBoxOptions();
      ADMappingPropertyName.Name = "ADMappingPropertyName" + i;
      ADMappingPropertyName.HideLabel = true;
      ADMappingPropertyName.Type = InputType.Text;
      ADMappingPropertyName.Value = ADMappings[i].adPropertyName;
      ADMappingPropertyName.IsRequired = false;
      ADMappingPropertyName.ViewType = ControlLayout.Horizontal;
      ADMappingPropertyName.IsRequired = true;

      let ADMappingIncludeUpdate = new CheckBoxOptions();
      ADMappingIncludeUpdate.Name = "ADMappingIncludeUpdate" + i;
      ADMappingIncludeUpdate.Value = ADMappings[i].includeInUpdate;
      ADMappingIncludeUpdate.IsDisabled = true;


      objectMappingOptions.push(ADMappingType, ADMappingProperty, ADMappingPropertyName, ADMappingIncludeUpdate);
      ADMappingOptions.push(objectMappingOptions);
      ADMappingCount += 1;

    }
    return [ADMappingOptions, ADMappingCount];
  }
  deleteADMapping(deletedADMApping: any) {
    let deletedMappingIndex: number = this.AddMappingsOptions.indexOf(deletedADMApping);
    if (deletedMappingIndex !== -1) {
      this.AddMappingsOptions.splice(deletedMappingIndex, 1);
      for (var i = 0; i < deletedADMApping.length; i++) {
        this.AddActiveDirectoryForm.removeControl(deletedADMApping[i].Name);
      }
    }
  }
  typeChange(typeValue) {
    if (typeValue == this.connectionTypeGroupId) {
      this.AddShowBuiltInGroupsVisible = true;
    }
    else {
      this.AddShowBuiltInGroupsVisible = false;
    }
  }

  nextStep() {
    const nextStep = this.currentStep$.value + 1;
    if (nextStep > this.formsCount) {
      return;
    }
    this.currentStep$.next(nextStep);
  }

  prevStep() {
    const prevStep = this.currentStep$.value - 1;
    if (prevStep === 0) {
      return;
    }
    this.currentStep$.next(prevStep);
  }
  ngAfterViewInit(): void {
    // Initialize form wizard
    //this.wizard =new (KTWizard as any)(this.el.nativeElement, {
    //  startStep: 1,
    //  clickableSteps: true
    //});

    // Validation before going to next page

    this.wizard.on('beforeNext', (wizardObj) => {
      if (wizardObj.currentStep === 1) {
        wizardObj.stop();

        let ResultModel = this.AddActiveDirectoryForm.value;
        if ((ResultModel.AddTypeOptions == undefined) || (ResultModel.AddDomain == undefined)
          || ResultModel.AddTypeOptions == null || ResultModel.AddDomain == null) {
          return;
        }


        let AddModel: ActiveDirectoryAddEditModel = new ActiveDirectoryAddEditModel();
        AddModel.ConnectionName = ResultModel.AddName;
        AddModel.Domain = ResultModel.AddDomain;
        let ADTypes = ResultModel.AddTypeOptions;
        let typeItemID: number;
        typeItemID = Number(ADTypes);
        AddModel.ADConnectionTypeItemID = ResultModel.AddTypeOptions != null ? typeItemID : null;
        AddModel.SamAccount = ResultModel.AddSamAccount;
        AddModel.Password = ResultModel.AddPassword;
        AddModel.ShowBuiltInGroups = ResultModel.AddShowBuiltInGroups;


        this.ActiveDirectoryService.CheckValidationandGetData(AddModel).subscribe((result) => {
          var data = result as any;
          if (data.val) {
            this.treeNodeData = data.treeData;
            this.errorIsFound = false;
            wizardObj.resume();
          }
          else {
            this.validationError = data.error;
            this.errorIsFound = true;
          }

        }, (error) => {

          return false;
        });
        // https://angular.io/guide/forms
        // https://angular.io/guide/form-validation

        // validate the form and use below function to stop the wizard's step
        // wizardObj.stop();
      }
    });

    // Change event
    //this.wizard.on('change', () => {
    //  setTimeout(() => {
    //    KTUtil.scrollTop();
    //  }, 500);
    //});
  }
  addActiveDirectory() {
    if (this.AddActiveDirectoryForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddActiveDirectoryForm.value;
      //console.log(ResultModel);
      let AddModel: ActiveDirectoryAddEditModel = new ActiveDirectoryAddEditModel();
      AddModel.ConnectionName = ResultModel.AddName;
      AddModel.Domain = ResultModel.AddDomain;
      AddModel.ADConnectionTypeItemID = ResultModel.AddTypeOptions != null ? Number(ResultModel.AddTypeOptions) : null
      AddModel.SamAccount = ResultModel.AddSamAccount;
      AddModel.Password = ResultModel.AddPassword;
      AddModel.ShowBuiltInGroups = ResultModel.AddShowBuiltInGroups;
      AddModel.PermissionSetID = ResultModel.AddPermissionSet != null ? Number(ResultModel.AddPermissionSet) : null
      AddModel.LangKey = ResultModel.AddLanguage;
      AddModel.WelcomeTemplateID = ResultModel.AddWelcomeMsgTemp != null ? Number(ResultModel.AddWelcomeMsgTemp) : null
      AddModel.ImagesFileProviderName = ResultModel.AddFileProvider
      AddModel.MarkAsInactive = ResultModel.AddMarkInactive
      AddModel.AddToDailyJob = ResultModel.AddDailyJob

      for (let j = 0; j < this.AddMappingsCount; j++) {
        let addMAppingType = ResultModel["ADMappingType" + j];
        if (addMAppingType == undefined)
          continue;
        let editMAppingProperty = ResultModel["ADMappingProperty" + j];
        let editMAppingPropertyName = ResultModel["ADMappingPropertyName" + j];

        let adMAppingObj: ADMappingModel = new ADMappingModel();
        adMAppingObj.ADMappingTypeItemID = Number(addMAppingType);
        adMAppingObj.BBSFPropertyName = editMAppingProperty;
        adMAppingObj.ADPropertyName = editMAppingPropertyName;
        AddModel.ADMappings.push(adMAppingObj);
      }

      this.ActiveDirectoryService.AddActiveDirectory(AddModel).subscribe((result) => {
        debugger;
        this.AddActiveDirectoryForm.reset();
        this.router.navigate(['/Admin/ADConnection']);

      }, (error) => {

      })
    }
  }

  onSubmit() {
    this.submitted = true;
    this.addActiveDirectory();
  }

  ngOnDestroy() {
    //  this.wizard = undefined;
  }
}

